import { required } from "ra-core";
import { BooleanInput } from "@/components/admin/boolean-input";
import { AutocompleteArrayInput } from "@/components/admin/autocomplete-array-input";
import { AutocompleteInput } from "@/components/admin/autocomplete-input";
import { DateTimeInput } from "@/components/admin/date-time-input";
import { ReferenceArrayInput } from "@/components/admin/reference-array-input";
import { ReferenceInput } from "@/components/admin/reference-input";
import { SelectInput } from "@/components/admin/select-input";
import { TextInput } from "@/components/admin/text-input";
import { AutocompleteCompanyInput } from "../companies/AutocompleteCompanyInput";
import { contactOptionText } from "../misc/ContactOption";

const meetingTypes = [
  { id: "discovery", name: "Descubrimiento" },
  { id: "demo", name: "Demo" },
  { id: "technical", name: "Técnica" },
  { id: "commercial", name: "Comercial" },
  { id: "follow_up", name: "Seguimiento" },
  { id: "other", name: "Otra" },
];

export const MeetingInputs = ({
  participants = false,
  taskCreation = false,
}: {
  participants?: boolean;
  taskCreation?: boolean;
}) => (
  <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
    <TextInput source="title" validate={required()} helperText={false} />
    <SelectInput
      source="meeting_type"
      choices={meetingTypes}
      defaultValue="other"
      helperText={false}
    />
    <ReferenceInput source="company_id" reference="companies">
      <AutocompleteCompanyInput label="resources.meetings.fields.company_id" />
    </ReferenceInput>
    <ReferenceInput source="deal_id" reference="deals">
      <AutocompleteInput optionText="name" helperText={false} />
    </ReferenceInput>
    {participants ? (
      <ReferenceArrayInput source="contact_ids" reference="contacts_summary">
        <AutocompleteArrayInput
          optionText={contactOptionText}
          helperText={false}
        />
      </ReferenceArrayInput>
    ) : null}
    <ReferenceInput source="sales_id" reference="sales">
      <AutocompleteInput
        optionText={(record) => `${record.first_name} ${record.last_name}`}
        helperText={false}
      />
    </ReferenceInput>
    <DateTimeInput
      source="starts_at"
      validate={required()}
      helperText={false}
    />
    <DateTimeInput source="ends_at" helperText={false} />
    <TextInput source="location" helperText={false} />
    <TextInput source="meeting_url" helperText={false} />
    <TextInput
      source="summary"
      multiline
      rows={3}
      helperText={false}
      className="md:col-span-2"
    />
    <TextInput source="key_points" multiline rows={3} helperText={false} />
    <TextInput source="decisions" multiline rows={3} helperText={false} />
    <TextInput source="next_steps" multiline rows={3} helperText={false} />
    {taskCreation ? (
      <BooleanInput
        source="create_tasks_from_next_steps"
        label="Crear tareas desde los próximos pasos"
        helperText={false}
      />
    ) : null}
    <TextInput source="outcome" multiline rows={3} helperText={false} />
  </div>
);
